export default __webpack_public_path__ + "static/livros_hero-c711d09e28271107884abc31f6b3161c.jpeg";